import {
  type EditMode,
  EditModeTypes,
  GeoElementTypes,
  RacemapGeoTypes,
} from '@racemap/utilities/types/geos';

// Default idle/selection mode: click to select a whole feature, drag to move it.
export const SimpleSelect: EditMode = {
  type: EditModeTypes.SimpleSelect,
  drawMode: 'simple_select',
};

// Vertex-editing mode: click a selected feature to expose and drag its individual waypoints.
export const DirectSelect: EditMode = {
  type: EditModeTypes.DirectSelect,
  drawMode: 'direct_select',
};

// Draw a new track by clicking waypoints; creates a LineString on finish.
export const AddTrack: EditMode = {
  type: EditModeTypes.AddTrack,
  drawMode: 'draw_line_string',
  targetGeoType: GeoElementTypes.LineString,
  targetElementType: RacemapGeoTypes.TRACK,
};

// Place a free-standing POI point anywhere on the map.
export const AddPoi: EditMode = {
  type: EditModeTypes.AddPoi,
  drawMode: 'draw_point',
  targetGeoType: GeoElementTypes.Point,
  targetElementType: RacemapGeoTypes.POI,
};

// Place a POI snapped to the nearest position on an existing track line.
export const AddPoiOnTrack: EditMode = {
  type: EditModeTypes.AddPoiOnTrack,
  drawMode: 'point_on_line_string',
  targetGeoType: GeoElementTypes.Point,
  targetElementType: RacemapGeoTypes.POI,
};

// Place a new split point snapped to an existing track line.
export const AddSplit: EditMode = {
  type: EditModeTypes.AddSplit,
  drawMode: 'point_on_line_string',
  targetGeoType: GeoElementTypes.Point,
  targetElementType: RacemapGeoTypes.SPLIT,
};

// Reposition an existing split by dragging it along its track line.
export const ModifySplit: EditMode = {
  type: EditModeTypes.ModifySplit,
  drawMode: 'point_on_line_string',
  targetGeoType: GeoElementTypes.Point,
  targetElementType: RacemapGeoTypes.SPLIT,
};

// Extend an existing track by appending new waypoints to one of its ends.
export const ExpandTrack: EditMode = {
  type: EditModeTypes.ExpandTrack,
  drawMode: 'expand_line_string',
  targetGeoType: GeoElementTypes.LineString,
  targetElementType: RacemapGeoTypes.TRACK,
};
